import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  natureIcon: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const NatureIcon = ({ style = {}, color = "#4CAF50" }) => {
  const classes = useStyles();

  return (
    <div className={classes.natureIcon} style={style}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Folha principal */}
        <path
          d="M12 2C8.5 2 6 4.5 6 8c0 2.5 1.5 4.5 3.5 6l2.5 2.5 2.5-2.5c2-1.5 3.5-3.5 3.5-6 0-3.5-2.5-6-6-6z"
          fill={color}
        />
        {/* Detalhes da folha */}
        <path
          d="M12 4c-2.2 0-4 1.8-4 4 0 1.5 1 2.8 2.2 3.5l1.8 1.8 1.8-1.8c1.2-.7 2.2-2 2.2-3.5 0-2.2-1.8-4-4-4z"
          fill="none"
          stroke={color}
          strokeWidth="0.5"
        />
        {/* Caule */}
        <path
          d="M12 18v4"
          stroke={color}
          strokeWidth="2"
          fill="none"
        />
        {/* Pequenas folhas laterais */}
        <path
          d="M8 16l2-2M16 16l-2-2"
          stroke={color}
          strokeWidth="1.5"
          fill="none"
        />
      </svg>
    </div>
  );
};

export default NatureIcon;
